<template>
  <page-layout no-padding-top class="home_con">

    <article class="cur_content">

      <div class="con_wrap">

        <div class="con_top">
          <div class="sect_01">
            <display-container :section="221">
              <template slot-scope="{ component, row }">
                <div class="wrap">
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <p class="category" :style="`background-color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <p class="txt1" v-html="component.getText1(row)"></p>
                </div>
              </template>
            </display-container>
          </div>
          <div class="sect_02">
            <display-container :section="224">
              <template v-slot="{ component, row }">
                <div class="wrap s_con">
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <div class="txts">
                  	<p class="txt1" v-html="component.getText1(row)"></p>
										<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
               		</div>
                </div>
              </template>
            </display-container>
            <display-container :section="225">
              <template v-slot="{ component, row }">
                <div class="wrap s_con">
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <div class="txts">
                  	<p class="txt1" v-html="component.getText1(row)"></p>
										<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
               		</div>
                </div>
              </template>
            </display-container>
            <display-container :section="226">
              <template v-slot="{ component, row }">
                <div class="wrap s_con">
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <div class="txts">
                  	<p class="txt1" v-html="component.getText1(row)"></p>
										<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
               		</div>
                </div>
              </template>
            </display-container>
            <!--<display-container :section="227">
              <template v-slot="{ component, row }">
                <div class="wrap s_con">
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                </div>
              </template>
            </display-container>
            <display-container :section="228">
              <template v-slot="{ component, row }">
                <div class="wrap s_con">
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                </div>
              </template>
            </display-container>-->
          </div>

          <!-- middle AD 2 (모바일 전용) -->
          <div class="ad_wrap mid mid-01" v-if="isMobile">
            <div class="inner">

              <display-container :section="211" empty-bg-color="transparent">
                <template v-slot="{ component, row }">
                  <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
                </template>
              </display-container>

              <!-- M -->
              <!--<ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-5310971739125617"
               data-ad-slot="5892973781"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>-->

            </div>
          </div>

          <div class="sect_03">
            <display-container :section="222" class="full-width">
              <template v-slot="{ component, row }">
                <div class="wrap">
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <p class="category" :style="`background-color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                  <p class="subj">{{component.getTitle(row)}}</p>
                </div>
              </template>
            </display-container>
            <display-container :section="223" class="full-width">
              <template v-slot="{ component, row }">
                <div class="wrap">
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <p class="category" :style="`background-color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                  <p class="subj">{{component.getTitle(row)}}</p>
                </div>
              </template>
            </display-container>
          </div>
        </div>

      </div>

    </article>

    <!-- middle AD 1 -->
    <div class="ad_wrap mid">
      <div class="inner">

        <display-container :section="211" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!-- PC -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="3921416569"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <!--<Adsense v-bind:ad-slot="3921416569"></Adsense>-->

        <!-- M -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="5892973781"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <!--<Adsense v-bind:ad-slot="5892973781"></Adsense>-->

      </div>
    </div>


    <article class="cur_content market_main">

    	<div class="con_wrap">
    		<!--<div class="controller">
					<div class="left" @click="scrLeft"></div>
					<div class="right" @click="scrRight"></div>
				</div>-->
    		<div class="title">
					<p class="subj">Infographic</p>
					<router-link to="/market" class="more">more</router-link>
				</div>
				<div class="list_market scroller custom-scrollbar">
					<ul>
						<li class="ctnr" @click="goArticle(feed)" v-for="feed in getFeeds.slice(0, 12)" :key="feed.idx"><img :src="getFileExist(feed.feed_img)" class="fit_img"/></li>
					</ul>
				</div>
			</div>

    	<!-- middle AD 1 -->
			<div class="ad_wrap mid">
				<div class="inner">

					<display-container :section="211" empty-bg-color="transparent">
						<template v-slot="{ component, row }">
							<img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
						</template>
					</display-container>

				</div>
			</div>

    </article>

    <article class="cur_content">

      <div class="con_wrap">
        <div class="con_issue">

					<div class="sect_01">
						<div class="title">
							<p class="subj">Hot Issue</p>
						</div>
						<display-container :section="227" class="l_con">
							<template v-slot="{ component, row }">
								<div class="wrap l_con">
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
								</div>
							</template>
						</display-container>
						<display-container :section="228" class="l_con">
							<template v-slot="{ component, row }">
								<div class="wrap l_con">
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
								</div>
							</template>
						</display-container>
						<display-container :section="231" class="l_con">
							<template v-slot="{ component, row }">
								<div class="wrap l_con">
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
								</div>
							</template>
						</display-container>
						<display-container :section="232" class="l_con">
							<template v-slot="{ component, row }">
								<div class="wrap l_con">
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
								</div>
							</template>
						</display-container>
					</div>

					<!-- middle AD 4 (모바일 전용) -->
					<div class="ad_wrap mid" v-if="isMobile">
						<div class="inner">

							<display-container :section="211" empty-bg-color="transparent">
								<template v-slot="{ component, row }">
									<img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
								</template>
							</display-container>

						</div>
					</div>

					<div class="sect_02">
						<div class="title">
							<p class="subj"><i>Upcoming Tournaments</i></p>
							<router-link to="/tournaments" class="more">more</router-link>
						</div>
						<div class="tnmt_sche">

							<template v-for="tnmt in getUpcomingTournaments">
                <router-link :to="`/tournament/${tnmt.idx}`" class="ctnr" :key="tnmt.idx">
                  <div class="brand">
                    <p class="img"><img v-if="isFileExist(tnmt.brand_logo_img)" :src="tnmt.brand_logo_img.url"></p>
                  </div>
                  <div class="cont">
                    <h5 v-html="tnmt.title"></h5>
                    <h6>{{tnmt.country_name}}</h6>
                    <p>Location : {{tnmt.venue}}</p>
                    <p>Prize Pool : {{tnmt.prize_pool}}</p>
                    <!--<p>Event : {{tnmt.event_cnt}} Events</p>-->
                  </div>
                  <div class="date"><b>{{tnmt.start_date}}</b> ~ {{tnmt.end_date}}</div>
                </router-link>
              </template>

						</div>
					</div>

        </div>
      </div>

    </article>

    <!-- middle AD 1 -->
    <div class="ad_wrap mid">
      <div class="inner">

        <display-container :section="211" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

      </div>
    </div>

    <!--<article class="cur_content ranking">

      <div class="con_wrap">
				<div class="title">
					<p class="subj">Ranking</p>
					<router-link to="/ranking" class="more">more</router-link>
				</div>
        <div class="con_rank">
          <ul class="lst" id="lst">
            <li v-for="(group, index) in rankings.slice(0, 3)">
            	<div class="container" v-for="ranking in group" :key="ranking.idx">
								<h3>{{ ranking.title }}<i>{{ ranking.subject }}</i></h3>
								<table class="ranktable">
									<tbody>
										<tr>
											<th v-for="(row, cindex) in ranking.data.header" :key="`${ranking.idx}_header_${cindex}`">{{row.value}}</th>
										</tr>
										<tr v-for="(row, rindex) in ranking.data.body" :key="`${ranking.idx}_body_${rindex}`">
											<td v-for="(col, cindex) in row">
												<div v-if="cindex === 0">
													<span v-if="col.value">{{ col.value | comma }}</span>
													<span v-else>{{ rindex + 1 }}<sup>{{convertOrdinalNumber(rindex + 1)}}</sup></span>
												</div>
												<div v-else>
													<a v-if="col.link" :href="col.link" target="_blank">{{ col.value | comma }}</a>
													<span v-else>
													  <span v-if="ranking.data.header[cindex].value.toLowerCase() === 'country' && col.value === ''" class="tbd">TBD</span>
														<span v-else-if="ranking.data.header[cindex].value.toLowerCase() === 'country'" class="image"><img class="flag" :src="`/statics/img/flags/${col.value}.svg`"></span>
														<span v-else>{{ col.value | comma }}</span>
													</span>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
            </li>
          </ul>
        </div>
      </div>

    </article>-->

    <!-- middle AD 2 -->
    <!--<div class="ad_wrap mid m-hide">
      <div class="inner">

        <display-container :section="211" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

      </div>
    </div>-->

    <!-- middle AD 4 (모바일 전용) -->
    <!--<div class="ad_wrap mid" v-if="isMobile">
      <div class="inner">

        <display-container :section="211" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

      </div>
    </div>-->

    <article class="cur_content">

      <div class="con_wrap">
        <div class="con_mid_01">

          <div class="title">
						<p class="subj">Feature News</p>
					</div>

					<div class="sect_01">
						<display-container :section="233" class="dp">
							<template v-slot="{ component, row }">
								<div class="wrap">
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
								</div>
							</template>
						</display-container>
					</div>

					<div class="sect_02">
						<display-container :section="234" class="dp">
							<template v-slot="{ component, row }">
								<div class="wrap">
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
								</div>
							</template>
						</display-container>
						<display-container :section="235" class="dp">
							<template v-slot="{ component, row }">
								<div class="wrap">
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
								</div>
							</template>
						</display-container>
						<display-container :section="236" class="dp">
							<template v-slot="{ component, row }">
								<div class="wrap">
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
								</div>
							</template>
						</display-container>
						<display-container :section="237" class="dp">
							<template v-slot="{ component, row }">
								<div class="wrap">
									<div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
									<p class="subj">{{component.getTitle(row)}}</p>
									<p class="txt1" v-html="component.getText1(row)"></p>
									<p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
								</div>
							</template>
						</display-container>
					</div>

        </div>
      </div>

    </article>

    <!--<article class="cur_content">

      <div class="con_wrap">

        <div class="con_mid_02">
          <div class="left_con">
            <div class="sect_01">
              <div class="scr_outer">
                <div class="scr_inner">
                  <display-container :section="231" class="dp">
                    <template v-slot="{ component, row }">
                      <div class="wrap">
                        <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                        <p class="subj">{{component.getTitle(row)}}</p>
                        <p class="txt1" v-html="component.getText1(row)"></p>
                        <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                      </div>
                    </template>
                  </display-container>
                  <display-container :section="232" class="dp">
                    <template v-slot="{ component, row }">
                      <div class="wrap">
                        <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                        <p class="subj">{{component.getTitle(row)}}</p>
                        <p class="txt1" v-html="component.getText1(row)"></p>
                        <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                      </div>
                    </template>
                  </display-container>
                  <display-container :section="233" class="dp">
                    <template v-slot="{ component, row }">
                      <div class="wrap">
                        <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                        <p class="subj">{{component.getTitle(row)}}</p>
                        <p class="txt1" v-html="component.getText1(row)"></p>
                        <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                      </div>
                    </template>
                  </display-container>
                </div>
              </div>
            </div>
            <div class="sect_02">
              <display-container :section="234" class="l_con">
                <template v-slot="{ component, row }">
                  <div class="wrap l_con">
                    <p class="subj">{{component.getTitle(row)}}</p>
                    <p class="txt1" v-html="component.getText1(row)"></p>
                    <p class="category">{{component.getCate(row)}}</p>
                    <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  </div>
                </template>
              </display-container>

              <div class="rt_con">
                <display-container :section="235">
                  <template v-slot="{ component, row }">
                    <div class="wrap s_con">
                      <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                      <p class="subj">{{component.getTitle(row)}}</p>
                      <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                    </div>
                  </template>
                </display-container>
                <display-container :section="236">
                  <template v-slot="{ component, row }">
                    <div class="wrap s_con">
                      <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                      <p class="subj">{{component.getTitle(row)}}</p>
                      <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                    </div>
                  </template>
                </display-container>
              </div>
            </div>
          </div>
          <div class="sect_03">
            <display-container :section="237">
              <template v-slot="{ component, row }">
                <div class="wrap">
                  <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                  <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                  <p class="subj">{{component.getTitle(row)}}</p>
                  <p class="txt1" v-html="component.getText1(row)"></p>
                </div>
              </template>
            </display-container>
          </div>
        </div>

      </div>

    </article>-->

    <!-- middle AD 2 -->
    <div class="ad_wrap mid m-hide">
      <div class="inner">

        <display-container :section="211" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!-- PC -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="3921416569"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <!--<Adsense v-bind:ad-slot="3921416569"></Adsense>-->

        <!-- M -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="5892973781"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <!--<Adsense v-bind:ad-slot="5892973781"></Adsense>-->

      </div>
    </div>

    <!-- middle AD 4 (모바일 전용) -->
    <div class="ad_wrap mid" v-if="isMobile">
      <div class="inner">

        <display-container :section="211" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!-- M -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="5892973781"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <!--<Adsense v-bind:ad-slot="5892973781"></Adsense>-->

      </div>
    </div>

    <article class="cur_content">

      <div class="con_wrap">

        <div class="con_btm">
          <div class="title">
            <router-link to="/news/">Latest News</router-link>
            <drop-down title="Categories" :data="getActiveCategories" key-name="idx" value-name="name" :action="clickDrowdownRow"></drop-down>
          </div>
          <ul class="lst" id="lst">
            <li v-for="post in getLatestPostsForHome" :key="post.idx">
              <post-container :post="post"></post-container>
<!--              <router-link :to="`/article/${post.idx}`">-->
<!--                <p class="img"><img v-if="isFileExist(post.post_img)" :src="post.post_img.url" class="fit_img"></p>-->
<!--                <p class="category" :style="`color: ${post.post_cate_color}`">{{post.post_cate_txt}}</p>-->
<!--                <p class="subj">{{post.title}}</p>-->
<!--              </router-link>-->
            </li>
          </ul>
        </div>

      </div>

    </article>

    <article>
			<display-container :section="108" class="ad_wall" v-if="isCurrentGNB('home')">
				<template v-slot="{ component, row }"></template>
			</display-container>
		</article>

  </page-layout>
</template>

<script>
  import Vue from 'vue'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import Adsense from '../components/Adsense'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import {mapGetters} from 'vuex'
  export default {
    name: 'Home',
    components: {
      PageLayout,
      DisplayContainer,
      PostContainer,
      DropDown,
      Adsense
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Asia-Pacific Poker News & Tournament`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Poker news, tournament schedule, rankings, reviews and live reporting`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Asia-Pacific Poker News & Tournament | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Poker news, tournament schedule, rankings, reviews and live reporting`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        dropdown: false,
				rankings: [{}, {}, {}, {}, {}, {}, {}, {}],
        loading: {},
      }
    },
		created() {
      this.$store.dispatch('callBrands')
      this.$store.dispatch('callUpcomingTournaments')
    },
		activated () {
      this.$store.dispatch('callFeeds')
      if (this.getRouteQueryIdx) {
        if (this.isMobile) {
          this.$router.replace(`/market/article/${this.getRouteQueryIdx}`)
        } else {
          this.showModalAfterGetData(this.getRouteQueryIdx)
        }
      }
    },
    mounted() {
      this.$store.dispatch('callCategories')
      this.$store.dispatch('callLatestPosts')
			this.getRankings()
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getActiveCategories',
        'getLatestPostsForHome',
				'getFeeds',
				'getBrands',
				'getLatestPosts',
        'getUpcomingTournaments'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
    },
    methods: {
      ...CommonMethods,
      clickDrowdownRow (row) {
        this.$router.push({path: `/news/cate/${row.idx}`})
      },
			getRankings () {
        this.axios.get('/rankings').then(rs => {
          this.rankings = this.division(rs.data, 1)
        })
      },
      division (arr, n) {
        const length = arr.length
        const divide = Math.floor(length / n) + (Math.floor(length%n) > 0 ? 1 : 0)
        const newArr = []
        for (let i = 0; i <= divide; i++) {
          newArr.push(arr.splice(0, n))
        }
        return newArr.filter(x => x.length > 0)
      },
			goArticle (row) {
        this.$router.push(`/market/article/${row.idx}`)
      },
			scrLeft() {
				let content = document.querySelector(".scroller");
				content.scrollLeft -= 1270;
			},
			scrRight() {
				let content = document.querySelector(".scroller");
				content.scrollLeft += 1270;
			},
			isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
    }
  }
</script>

<style scoped>
  .ad_wrap /deep/ a {
    padding: 20px 0;
  }
  .ad_wrap /deep/ a img {
    width: 728px !important;
    height: 90px !important;
  }
  .cur_content {
    padding-top: 0px;
  }
  .cur_content.white {
    background: #fff;
  }
  .cur_content .con_wrap {
		position: relative;
    width: 1220px;
    padding: 0;
    margin: 0 auto;
  }
  .cur_content .con_wrap .con_top {
		display: flex;
    align-items: flex-start;
  }
  .cur_content.market .con_wrap {
		/*padding-bottom: 50px;*/
  }
  .cur_content .con_wrap .title {
		padding: 20px 0 24px;
		border-top: 1px solid #000;
		position: relative;
  }
  .cur_content .con_wrap .title .subj {
		font-family: 'Roboto Slab';
    font-size: 28px;
    font-weight: 900;
    color: #000;
    line-height: 1.25em;
    display: inline-block;
    letter-spacing: -0.02em;
  }
	.cur_content .con_wrap .title .subj:before {
		content: "";
    display: inline-block;
    width: 30px;
    height: 33px;
    background: url(/statics/img/bi_title.png) no-repeat;
    background-size: contain;
    margin-right: 10px;
		float: left;
  }
	.cur_content .con_wrap .title .subj i {
		float: left;
		width: 60%;
  }
	.cur_content .con_wrap .title .more {
    position: absolute;
		right: 0;
		top: 50%;
		font-size: 14px;
		font-weight: 900;
		color: #000;
		padding: 8px 20px;
		border: 1px solid #aaa;
		border-radius: 5.0em;
		line-height: 1.0em;
		transform: translate(0, -50%);
  }
	.cur_content .con_wrap .title .more:hover {
    background: #fff;
  }
  .cur_content .con_wrap .display-container .wrap {
    display: inline-block;
    width: 100%;
    text-align: left;
  }
  .cur_content .con_wrap .display-container .img {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .cur_content .con_wrap .con_top .sect_01 {
    padding: 0 19px;
    margin: 0 20px;
    border: solid #e5e5e5;
    border-width: 0 1px 0 1px;
    min-height: 580px;
    width: calc(54% - 40px);
    order: 2;
  }
  .cur_content .con_wrap .con_top .sect_01 .display-container {
    display: inline-block;
    width: 100%;
  }
  .cur_content .con_wrap .con_top .sect_01 .display-container .img {
    height: 440px;
  }
  .cur_content .con_wrap .con_top .sect_01 .display-container .category {
    display: inline-block;
    font-size: 14px;
    font-weight: 800;
    color: #fff;
    line-height: 1.0em;
    background: #368ee9;
    padding: 8px 16px;
    border-radius: 0 0 1.2em 0;
    transform: translate(0, -50%);
    position: relative;
    z-index: 2;
  }
  .cur_content .con_wrap .con_top .sect_01 .display-container .subj {
    font-size: 24px;
    font-weight: 750;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.03em;
    word-break: normal;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_top .sect_01 .display-container .txt1 {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.6em;
    margin-top: 16px;
    word-break: normal;
    max-height: 3.0em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_top .sect_02 {
    display: flex;
    flex-flow: column;
    width: 23%;
    order: 3;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container .wrap.s_con {
    display: inline-block;
    width: 100%;
    padding: 20px 0 20px 0;
    border-bottom: 1px solid #e5e5e5;
    min-height: 190px;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container:first-child .wrap.s_con {
    padding: 0 0 20px 0;
    min-height: 170px;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container:last-child .wrap.s_con {
    padding: 20px 0 0 0;
    border-bottom: none;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container .img {
    float: right;
    width: 120px;
    height: 100px;
		margin: 0 0 5px 15px;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container .subj {
    font-size: 17px;
    font-weight: 700;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
		word-break: normal;
		margin-bottom: 10px;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container .txt1 {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.02em;
    line-height: 1.4em;
		word-break: normal;
    margin-top: 10px;
		max-height: 5.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_top .sect_02 .display-container .category {
    font-size: 12px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 10px;
  }
  .cur_content .con_wrap .con_top .sect_03 {
    display: flex;
    flex-flow: column;
    width: 23%;
    order: 1;
  }
  .cur_content .con_wrap .con_top .sect_03 .display-container {
    display: inline-block;
    margin-bottom: 25px;
  }
  .cur_content .con_wrap .con_top .sect_03 .display-container:last-child {
    margin-bottom: 0;
  }
  .cur_content .con_wrap .con_top .sect_03 .display-container .img {
    height: 200px;
  }
  .cur_content .con_wrap .con_top .sect_03 .display-container .category {
    display: inline-block;
    font-size: 14px;
    font-weight: 800;
    color: #fff;
    line-height: 1.0em;
    background: #368ee9;
    padding: 8px 16px;
    border-radius: 0 0 1.2em 0;
    transform: translate(0, -50%);
    position: relative;
    z-index: 2;
  }
  .cur_content .con_wrap .con_top .sect_03 .display-container .subj {
    font-size: 18px;
    font-weight: 700;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    margin-top: -5px;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 {
    padding-top: 20px;
    border-top: 1px solid #000;
  }
  .cur_content .con_wrap .con_mid_02 .left_con {
    display: inline-block;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 {
    display: inline-block;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
  }
  /deep/ .cur_content .con_wrap .display-container.dp a > div img {
    width: 100% !important;
    object-fit: cover;
    transition: .15s ease-in-out;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container {
    display: inline-block;
    width: 315px;
    padding: 0 20px 0 19px;
    border-right: 1px solid #e5e5e5;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container:first-child {
    padding-left: 0;
    width: 295px;
    min-height: 300px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container:last-child {
    padding-right: 0;
    width: 295px;
    border-right: none;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container .img {
    height: 160px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container .subj {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    margin-top: 15px;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container .txt1 {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.6em;
    margin-top: 10px;
    word-break: normal;
    max-height: 3.0em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 .sect_01 .display-container .category {
    font-size: 12px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 15px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .rt_con {
    display: inline-block;
    width: 275px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container.l_con {
    display: inline-block;
    width: 630px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.l_con {
    display: inline-block;
    height: 190px;
    padding: 0 350px 0 0;
    position: relative;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.l_con .img {
    position: absolute;
    top: 0;
    right: 40px;
    width: 275px;
    height: 225px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.l_con .subj {
    font-size: 22px;
    font-weight: 600;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.l_con .txt1 {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.6em;
    margin-top: 10px;
    word-break: normal;
    max-height: 4.4em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.l_con .category {
    font-size: 14px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 20px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.s_con {
    display: inline-block;
    width: 100%;
    padding: 20px 120px 20px 0;
    border-bottom: 1px solid #e5e5e5;
    min-height: 120px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container:first-child .wrap.s_con {
    padding: 0 120px 20px 0;
    min-height: 100px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.s_con .img {
    position: absolute;
    right: 0;
    width: 100px;
    height: 80px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.s_con .subj {
    font-size: 15px;
    font-weight: 600;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 .sect_02 .display-container .wrap.s_con .category {
    font-size: 12px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 15px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_03 {
    display: inline-block;
    width: 295px;
    margin-left: 20px;
    padding-left: 20px;
    min-height: 570px;
    border-left: 1px solid #e5e5e5;
  }
  .cur_content .con_wrap .con_mid_02 .sect_03 .display-container .img {
    display: inline-block;
    width: 275px;
    height: 300px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_03 .display-container .category {
    font-size: 14px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 20px;
  }
  .cur_content .con_wrap .con_mid_02 .sect_03 .display-container .subj {
    font-size: 22px;
    font-weight: 600;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    max-height: 3.9em;
    margin-top: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_02 .sect_03 .display-container .txt1 {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.6em;
    margin-top: 10px;
    word-break: normal;
    max-height: 6.2em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .cur_content .con_wrap .con_mid_01 .sect_01 {
    display: inline-block;
		width: 620px;
		margin-right: 20px;
		padding: 0 20px 0 0;
		border-right: 1px solid #e5e5e5;
  }
  /deep/ .cur_content .con_wrap .display-container.dp a > div img {
    width: 100% !important;
    object-fit: cover;
    transition: .15s ease-in-out;
  }
  .cur_content .con_wrap .con_mid_01 .sect_01 .display-container {
    display: inline-block;
		width: 100%;
  }
  .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .img {
    height: 440px;
  }
  .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .subj {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.03em;
    word-break: normal;
    max-height: 3.9em;
    overflow: hidden;
		margin-top: 15px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .txt1 {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.6em;
    margin-top: 16px;
    word-break: normal;
    max-height: 4.0em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_01 .sect_01 .display-container .category {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.0em;
    margin-top: 15px;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 {
    display: inline-block;
		width: 580px;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 .display-container {
    display: inline-block;
    width: calc((100% - 20px) / 2);
    position: relative;
		margin-right: 20px;
		margin-bottom: 25px;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 .display-container:nth-child(even) {
    margin-right: 0;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .img {
    height: 190px;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .subj {
    font-size: 18px;
    font-weight: 700;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    margin-top: 15px;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .txt1 {
    display: none;
  }
  .cur_content .con_wrap .con_mid_01 .sect_02 .display-container .category {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.0em;
    margin-top: 10px;
  }
	.cur_content .con_wrap .con_issue .sect_01 {
    display: inline-block;
    width: 850px;
		margin-right: 20px;
    padding: 0 30px 0 0;
  }
  .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con {
    display: inline-block;
		width: 100%;
    height: 190px;
		margin-bottom: 20px;
    padding: 0 0 0 300px;
    position: relative;
  }
  .cur_content .con_wrap .con_issue .sect_01 .display-container:last-child .wrap.l_con {
    margin-bottom: 0;
  }
  .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .img {
    position: absolute;
    top: 0;
    left: 0;
    width: 275px;
    height: 190px;
  }
  /deep/ .cur_content .con_wrap .con_issue .sect_01 .display-container img {
    max-width: 275px;
  }
  .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .subj {
    font-size: 22px;
    font-weight: 750;
    color: #000;
    line-height: 1.35em;
    letter-spacing: -0.02em;
    word-break: normal;
    max-height: 3.9em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .txt1 {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.6em;
    margin-top: 10px;
    word-break: normal;
    max-height: 4.6em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .cur_content .con_wrap .con_issue .sect_01 .display-container .wrap.l_con .category {
    font-size: 14px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 15px;
  }
  .cur_content .con_wrap .con_issue .sect_02 {
    display: inline-block;
		width: 350px;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr {
		position: relative;
    display: inline-block;
		width: 100%;
		color: #000;
		background: #e5ede8;
		padding: 22px 20px;
		border-radius: 8px;
		margin-bottom: 10px;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr:hover {
		background: #dbe6df;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr:nth-child(odd) {
		/*background: #eaeaea;*/
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .brand {
    display: inline-block;
		width: 50px;
		height: 50px;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .brand img {
    width: 100%;
    border-radius: 4px;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont {
		display: inline-block;
    width: 260px;
		padding-left: 20px;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont h5 {
		display: block;
		width: 165px;
    font-size: 17px;
		font-weight: 700;
		line-height: 1.1em;
		letter-spacing: -0.02em;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont h6 {
    font-size: 14px;
		font-weight: 500;
		color: #000;
		margin-bottom: 5px;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .cont p {
    font-size: 14px;
		font-weight: 400;
		color: #666;
		letter-spacing: -0.01em;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .date {
    position: absolute;
		top: 20px;
		right: 20px;
		font-weight: 900;
		color: #008c03;
		text-align: right;
		letter-spacing: -0.05em;
		line-height: 1.6em;
  }
  .cur_content .con_wrap .con_issue .sect_02 .ctnr .date b {
		display: block;
    font-size: 24px;
		font-weight: 900;
  }

	.cur_content .con_wrap .con_btm a {
		font-family: 'Roboto Slab';
    font-size: 28px;
    font-weight: 900;
    color: #000;
    line-height: 1.3em;
    display: inline-block;
    letter-spacing: -0.02em;
  }
  .cur_content .con_wrap .con_btm a:before {
		content: "";
    display: inline-block;
    width: 30px;
    height: 33px;
    background: url(/statics/img/bi_title.png) no-repeat;
    background-size: contain;
    margin-right: 10px;
  }
  .cur_content .con_wrap .con_btm a:after {
		content: "";
    display: inline-block;
    width: 14px;
    height: 16px;
    background: url(/statics/img/a_arrow.png) no-repeat;
    background-size: contain;
    margin-left: 14px;
    margin-top: 12px;
  }
  .cur_content .con_wrap .con_btm li {
    display: inline-block;
    width: 315px;
    min-height: 290px;
    padding: 0 20px 0 19px;
    margin-bottom: 30px;
    border-right: 1px solid #e5e5e5;
  }
  .cur_content .con_wrap .con_btm li:nth-child(4n+1) {
    padding-left: 0;
    width: 295px;
  }
  .cur_content .con_wrap .con_btm li:nth-child(4n+4) {
    padding-right: 0;
    width: 295px;
    border-right: none;
  }
	.cur_content .con_wrap .controller div {
		position: absolute;
		top: 53%;
		left: 50%;
		cursor: pointer;
		width: 50px;
		height: 50px;
	}
	.cur_content .con_wrap .controller .left {
		transform: translate(-650px, 0);
	}
	.cur_content .con_wrap .controller .right {
		transform: translate(600px, 0);
	}
	.cur_content .con_wrap .controller div:after {
		content: "";
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		width: 30px;
		height: 30px;
		border: rgba(0,0,0,0.5) solid;
		border-width: 0 0 2px 2px;
		z-index: 10;
	}
	.cur_content .con_wrap .controller .left:after {
		transform: translate(-50%, -50%) rotate(45deg);
	}
	.cur_content .con_wrap .controller .right:after {
		transform: translate(-50%, -50%) rotate(-135deg);
	}
	.cur_content .con_wrap .scroller {
		overflow-x: auto;
		margin: 0 auto;
		transition: 0.5s;
		scroll-behavior: smooth;
	}
	.cur_content .con_wrap .list_market {
    overflow: hidden;
    height: 482px;
	}
	.cur_content .con_wrap .list_market .ctnr {
		display: inline-block;
    width: calc((100% - 40px) / 5);
		height: 236px;
		margin-right: 10px;
    margin-bottom: 10px;
		cursor: pointer;
		position: relative;
    background: #00270e;
    border-radius: 8px;
    overflow: hidden;
	}
	.cur_content .con_wrap .list_market .ctnr:nth-child(5n) {
		margin-right: 0;
	}
	.cur_content .con_wrap .list_market .ctnr:nth-child(n+5) {
/*		margin-bottom: 0;*/
	}
	.cur_content .con_wrap .list_market .ctnr img {
		width: 100%;
    object-fit: contain;
	}
	.cur_content .con_wrap .con_rank ul li {
		display: inline-block;
		width: calc((100% - 40px) / 3);
		margin-right: 20px;
	}
	.cur_content .con_wrap .con_rank ul li:last-child {
		margin-right: 0;
	}
	.cur_content .con_wrap .con_rank .container {
		border-radius: 10px;
		overflow: hidden;
	}
	.cur_content .con_wrap .con_rank .container h3 {
		font-size: 16px;
		font-weight: 400;
		color: #00ff64;
		line-height: 1.4em;
		text-align: center;
		background: #003501;
		padding: 15px;
	}
	.cur_content .con_wrap .con_rank .container h3 i {
		display: block;
		font-size: 19px;
		font-weight: 800;
		color: #fff;
	}
	.cur_content .con_wrap .con_rank .container .ranktable {
		width: 100%;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.03em;
    background: #fff;
	}
	.cur_content .con_wrap .con_rank .container .ranktable tr {
		height: 40px;
	}
	.cur_content .con_wrap .con_rank .container .ranktable tr:nth-child(odd) {
		background: #fafafa;
	}
	.cur_content .con_wrap .con_rank .container .ranktable th {
		font-size: 12px;
		font-weight: 900;
    /*color: rgba(0,255,100,1.0);
    background: #000;*/
		color: #333;
		/*background: #008c03;*/
		background: #e9e9e9;
    vertical-align: middle;
		text-align: center;
	}
	/*.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(1) {
		width: 15%;
	}
	.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(2) {
		width: 15%;
	}
	.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(3) {
		width: 37%;
	}*/
	.cur_content .con_wrap .con_rank .container .ranktable td {
		vertical-align: middle;
    text-align: center;
		line-height: 1.0em;
	}
	.cur_content .con_wrap .con_rank .container .ranktable td .flag {
		position: relative;
    width: 18px;
	}
	.cur_content .con_wrap .con_rank .container .ranktable td .image {
		position: relative;
		display: inline-block;
	}
	.cur_content .con_wrap .con_rank .container .ranktable td .image:after {
		content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid rgba(0,0,0,0.25);
    z-index: 1;
	}
	.cur_content .con_wrap .con_rank .container .ranktable td a {
		color: #379339;
    text-decoration: underline;
	}
	.cur_content .con_wrap .con_rank .container .ranktable td .tbd {
		font-size: 0.9em;
    opacity: 0.5;
	}
	.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(1),
	.cur_content .con_wrap .con_rank .container .ranktable td:nth-child(1) {
/*		width: 15%;*/
    padding-left: 10px;
	}
	.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(2),
	.cur_content .con_wrap .con_rank .container .ranktable td:nth-child(2) {
/*		width: 15%;*/
	}
	.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(3),
	.cur_content .con_wrap .con_rank .container .ranktable td:nth-child(3) {
/*		width: 37%;*/
	}
	.cur_content .con_wrap .con_rank .container .ranktable th:nth-child(4),
	.cur_content .con_wrap .con_rank .container .ranktable td:nth-child(4) {
    padding-right: 10px;
	}
  .p-hide {
    display: none;
  }
	.custom-scrollbar::-webkit-scrollbar {
  	width: 6px;
		height: 6px;
		display: none;
	}
	.custom-scrollbar::-webkit-scrollbar-track {
		border-radius: 10px;
		background-color: rgba(0,0,0,0.08);
	}
	.custom-scrollbar::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: rgba(0,0,0,0.25);
	}
	.custom-scrollbar::-webkit-scrollbar-button {
		width: 0;
		height: 0;
	}
	/* firefox scrollbar */
	.custom-scrollbar {
		scrollbar-width: none;
		scrollbar-color: rgba(0,0,0,0.25) rgba(0,0,0,0.08);
	}
	/* on wallpaper */
	#q-app.wallpaper .ranktable {
		background: #f9f9f9;
	}
	.ad_wall {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000;
		z-index: -1;
	}
	/deep/ .ad_wall a {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	/deep/ .ad_wall a > div {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	/deep/ .ad_wall a > div > img {
		position: fixed;
		width: 2500px !important;
		height: 1080px !important;
		left: 50%;
		transform: translate(-50%, 0);
	}
</style>
